/**
 * 会员信息
 */
import React from 'react';
import { Input, Row, Col, Button ,Select,DatePicker, Tooltip, Icon} from 'antd';
import PageLayout from '../../ui/PageLayout';
import http from '../../../axios/http';
//会员选择
import MemberSelect from '../../barrier/MemberSelect';
import Loading from '../../ui/Loading';
import BatchVehicleApprove from './BatchVehicleApprove';
import { global_data } from '../../ui/auth'


class BatchVehicleIndex extends React.Component {

    columns = [{
        title: '记录编号',
        dataIndex: 'id',
        width: '5%',
    }, {
        title: '车架号',
        dataIndex: 'vin',
        width: '15%',
    }, {
        title: '所属公司/项目',
        dataIndex: 'projectId',
        width: '10%',
    }, {
        title: '车辆状态',
        dataIndex: 'state',
        width: '5%',
        format: { 0: '离场', 1: '在场' }
    },{
        title: '车牌号',
        dataIndex: 'plateNo',
        width: '7%'
    }, {
        title: '账期在场天数',
        dataIndex: 'parkNum',
        width: '6%',
    }, {
        title: '入场时间',
        dataIndex: 'entryTime',
        width: '13%',
    }
    , {
        title: '入场人',
        dataIndex: 'entryOperator',
        width: '7%'
    }
    , {
        title: '入场备注',
        dataIndex: 'entryRemark',
        width: '6%'
    }, {
        title: '离场时间',
        dataIndex: 'leaveTime',
        width: '13%',
    }
    , {
        title: '离场人',
        dataIndex: 'leaveOperator',
        width: '7%'
    }
    , {
        title: '离场备注',
        dataIndex: 'leaveRemark',
        width: '6%'
    }
    ,{
        title: '操作',
        dataIndex: 'id',
        width: '4%',
        render: (text, record, index) => (
            <div>
                {global_data.authCode.includes("BARRIER_BATCH_VEHICLE_APPROVE")&&record.logId !== undefined?
                <Tooltip title="数据修正审批">
                    <Icon type="eye" theme="filled" className="table-operate-icon" onClick={this.detail.bind(this, text)} style={{ color: '#008000' }} />
                </Tooltip>
                : ''}
            </div>
        )
    }
];

    state = {
        loadData: '',
        queryData: {},
        loadingVisible: false
    };

    download = () => {
        this.setState({ loadingVisible: true });
        let queryData = this.state.queryData;
        queryData.pageSize = 5000;
        http.download({
            url: '/barrier/batchVehicle/download',
            data: queryData,
            fileName: "批量车出入库记录.xlsx",
            success: (res) => {
                this.setState({ loadingVisible: false });
            },
            error: (res) => {
                this.setState({ loadingVisible: false });
            }
        });
    }

    //详情
    detail = (info, e) => {
        this.setState({ loadingVisible: true });
        //读取竞价品信息
        http.get({
            url: '/barrier/batchVehicleLog/page',
            data: { batchVehicleId: info },
            success: (res) => {
                this.setState({ loadingVisible: false, detailVisible: true, logs: res});
            },
            error: (res) => {
                this.setState({ loadingVisible: false });
            }
        });
    }

    inputSearch = (value) => {
        let queryData = this.state.queryData;
        queryData.keyWord = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData)
    }
    selectChange = (field, value) => {
        let { queryData } = this.state;
        queryData[field] = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    memberSelectChange = (field, value) => {
        let queryData = this.state.queryData;
        queryData[field] = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    selectEntryDateChange = (e,val) => {
        let queryData = this.state.queryData;
        queryData["entryDateStr"] = val;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    selectLeaveDateChange = (e,val) => {
        let queryData = this.state.queryData;
        queryData["leaveDateStr"] = val;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={20}>
                                <Input.Search
                                    placeholder="车架号等关键字"
                                    onSearch={this.inputSearch}
                                    enterButton
                                    style={{ width: 400 }}
                                />
                                <Select onChange={this.selectChange.bind(this, "state")} allowClear={true} style={{ width: "150px", marginLeft: '10px' }}>
                                    <Select.Option value="">全部</Select.Option>
                                    <Select.Option value="1">在场</Select.Option>
                                    <Select.Option value="0">离场</Select.Option>
                                </Select>
                                <MemberSelect onChange={this.memberSelectChange.bind(this, "projectId")} style={{ width: "200px", marginLeft: '10px' }} allowClear={true} />
                                <DatePicker placeholder='入场时间' onChange={this.selectEntryDateChange} style={{ width: "150px", marginLeft: '10px' }} />
                                <DatePicker placeholder='出场时间' onChange={this.selectLeaveDateChange} style={{ width: "150px", marginLeft: '10px' }} />
                            </Col>
                            <Col span={4} style={{ textAlign: "right" }}>
                                <Button type="primary" onClick={this.download}>导出</Button>
                            </Col>
                        </Row>
                    )}
                    rowKey="id"
                    url="/barrier/batchVehicle/page"
                    columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <BatchVehicleApprove
                    visible={this.state.detailVisible}
                    onCancel={() => { this.setState({ detailVisible: false, logs: [] }) }}
                    successCallback={this.state.loadData}
                    logs={this.state.logs}
                />
                <Loading visible={this.state.loadingVisible} message="处理中，请稍候..." />
            </div>
        )
    }
}

export default BatchVehicleIndex;